import React from "react";
import { motion } from "motion/react";

interface HeadingProps {
  placeholder: string;
  subheading?: string;
  className?: string;
}

export const Heading: React.FC<HeadingProps> = ({
  placeholder,
  subheading,
  className = "",
}) => {
  return (
    <div className={`flex flex-col items-center ${className}`}>
      <div className="overflow-hidden">
        <motion.div
          className="flex items-end justify-center"
          initial={{
            y: "100%",
            opacity: 0,
          }}
          whileInView={{
            y: 0,
            opacity: 1,
          }}
          viewport={{ once: true }}
          transition={{
            type: "spring",
            damping: 12,
            stiffness: 100,
            duration: 0.8,
          }}
        >
          <h2 className="font-gilroy-regular text-4xl sm:text-5xl lg:text-[64px] text-center lg:text-left leading-20">
            {placeholder}
          </h2>
          <div className="size-[6px] sm:size-[8px] lg:size-[10px] mb-6 sm:mb-5 md:mb-4 lg:mb-3 ml-2 bg-red-500 rounded-full" />
        </motion.div>
      </div>
      {subheading && (
        <h3 className="font-gilroy-regular hidden md:flex text-lg sm:text-xl lg:text-[24px] text-center mt-2">
          {subheading}
        </h3>
      )}
    </div>
  );
};
